import Head from "next/head"
import React from "react"

import Footer from "~/components/organisms/Footer"
import { LtiRegistrationLpPage } from "~/components/pages/ltiRegistrationLp"

const LtiRegistrationLp = () => {
  return (
    <>
      <Head>
        <title>Infra インターンで長期・有給インターンシップを探そう</title>
      </Head>
      <LtiRegistrationLpPage />
      <Footer />
    </>
  )
}

export default LtiRegistrationLp
